import { memo, useEffect, useMemo } from 'react';
import {
  useGetAccessDoorParams,
  useGetAccessories,
  useGetCoilParams,
  useGetComponents,
  useGetConnHands,
  useGetDrainPanParams,
  useGetErWheelParams,
  useGetFanParams,
  useGetFilterParams,
  useGetOpeningParams,
  useGetVoltages,
} from '../../dataHooks';
import { useLazyGetFanSettingsQuery, useProjectSyncdata } from '../../services';
import Loader from '../atom/Loader';
import BotContext from './context';
import BotContentInner from './BotContentInner';
import BotSummaryPanel from '../BotSummaryPanel';

const BotContent = () => {
  useProjectSyncdata()
  const { isLoading: voltagesLoading } = useGetVoltages();
  const { isLoading: componentsLoading } = useGetComponents();
  const { isLoading: accessoriesLoading } = useGetAccessories();
  const { isLoading: filterParamsLoading } = useGetFilterParams();
  const { isLoading: fanParamsLoading } = useGetFanParams(false);
  const { isLoading: coilParamsLoading } = useGetCoilParams();
  const { isLoading: connHandsLoading } = useGetConnHands();
  const { isLoading: rotaryParamsLoading } = useGetErWheelParams();

  // Get accessory params
  const { isLoading: openingLoading } = useGetOpeningParams();
  const { isLoading: drainPanLoading } = useGetDrainPanParams();
  const { isLoading: accessDoorLoading } = useGetAccessDoorParams();

  const [loadFanSettingsQuery1, { isLoading: fanSettings1Loading }] =
    useLazyGetFanSettingsQuery();
  const [loadFanSettingsQuery2, { isLoading: fanSettings2Loading }] =
    useLazyGetFanSettingsQuery();

  useEffect(() => {
    loadFanSettingsQuery1({ type: 'plenum', arr: '4' });
    loadFanSettingsQuery2({ type: 'plug', arr: '4' });
  }, []);

  const isLoading = useMemo(() => {
    return (
      voltagesLoading ||
      componentsLoading ||
      filterParamsLoading ||
      fanParamsLoading ||
      coilParamsLoading ||
      connHandsLoading ||
      fanSettings1Loading ||
      fanSettings2Loading ||
      accessoriesLoading ||
      openingLoading ||
      accessDoorLoading ||
      drainPanLoading ||
      rotaryParamsLoading
    );
  }, [
    voltagesLoading,
    componentsLoading,
    filterParamsLoading,
    fanParamsLoading,
    coilParamsLoading,
    connHandsLoading,
    fanSettings1Loading,
    fanSettings2Loading,
    accessoriesLoading,
    rotaryParamsLoading,
  ]);

  if (isLoading) {
    return <Loader className="bg-custom-grey" />;
  }
  return (
    <>
      <div className="bot-info__header"></div>
      <BotContext>
        <BotContentInner />
        <BotSummaryPanel />
      </BotContext>
    </>
  );
};

export default memo(BotContent);
